











import { defineComponent, ref, toRef, watch, computed } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { format, getNow, parse } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "ScheduledDateView",
  components: { BaseForm, BaseConfirm, BaseButton },
  props: {
    show: { type: Boolean },
    title: { type: String, default: $t("Schedule post") },
    scheduledTime: { type: String },
  },
  setup(props, { emit }) {
    const saving = ref(false);
    const values = ref<FormValues>({ date: "", time: "" });
    const fields = computed<FormFields>(() => [
      {
        name: "date",
        label: $t("Date"),
        type: "date",
      },
      {
        name: "time",
        label: $t("Time"),
        type: "time",
      },
    ]);

    const onSave = () => {
      const date = parse(`${values.value.date} ${values.value.time}`, "yyyy-MM-dd HH:mm", getNow());
      emit("save", date);
    };
    const onSetNow = (e: Event | null, date = getNow()) => {
      values.value.date = format(date, "yyyy-MM-dd");
      values.value.time = format(date, "HH:mm");
    };
    onSetNow(null, (props.scheduledTime && new Date(props.scheduledTime)) || undefined);

    const onClose = () => {
      onSetNow(null, (props.scheduledTime && new Date(props.scheduledTime)) || undefined);
      emit("close");
    };

    watch(
      toRef(props, "scheduledTime"),
      () => {
        onSetNow(null, (props.scheduledTime && new Date(props.scheduledTime)) || undefined);
      },
      { immediate: true }
    );

    return {
      saving,
      fields,
      values,
      onSave,
      onClose,
      onSetNow,
    };
  },
});
